import { onScopeDispose, readonly, ref, watchEffect } from "vue";

export type PageFilterValue = string | string[];

const pageState = ref<Record<string, PageFilterValue>>({});

export const assistantPageState = readonly(pageState);

export function useAssistantPageState(read: () => Record<string, PageFilterValue | null | undefined>) {
  const stop = watchEffect(() => {
    pageState.value = Object.fromEntries(
      Object.entries(read()).filter(
        (entry): entry is [string, PageFilterValue] => entry[1] != null && entry[1].length > 0,
      ),
    );
  });

  onScopeDispose(() => {
    stop();
    pageState.value = {};
  });
}

export default useAssistantPageState;
